let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gaWRH")).then(() => parcelRequire('4O2mo'));